import { defineStore } from "pinia";
import base from "./base"

export const useExternalShipmentsStore = defineStore('external_shipments', {
    state: () => ({
        shipments: [],
        stats: {
            in_transit: 0,
            delivered_this_month: 0,
            avg_delivery_days: null
        }
    }),
    getters: {
        // Obtener shipments ordenados por carrier_tracking
        sortedShipments: (state) => {
            return [...state.shipments].sort((a, b) => {
                // Sort by shipped_at descending (most recent first), nulls last
                const dateA = a.shipped_at ? new Date(a.shipped_at) : null
                const dateB = b.shipped_at ? new Date(b.shipped_at) : null
                if (!dateA && !dateB) return 0
                if (!dateA) return 1
                if (!dateB) return -1
                return dateB - dateA
            });
        },

        // Client-side computed stats as fallback/complement
        computedStats: (state) => {
            const shipments = state.shipments
            const now = new Date()
            const currentMonth = now.getMonth()
            const currentYear = now.getFullYear()

            // In transit: shipped but not received
            const inTransit = shipments.filter(s =>
                s.shipped_at && !s.received_at
            ).length

            // Pending: not shipped yet
            const pending = shipments.filter(s => !s.shipped_at).length

            // Delivered this month
            const deliveredThisMonth = shipments.filter(s => {
                if (!s.received_at) return false
                const d = new Date(s.received_at)
                return d.getMonth() === currentMonth && d.getFullYear() === currentYear
            }).length

            // Avg delivery days — use backend-computed transit_duration, filter out N/A (null) values
            const withDuration = shipments.filter(s => s.transit_duration != null && Number.isFinite(s.transit_duration))
            const avgDays = withDuration.length > 0
                ? Math.round(withDuration.reduce((sum, s) => sum + s.transit_duration, 0) / withDuration.length * 10) / 10
                : null

            return {
                in_transit: inTransit,
                pending: pending,
                delivered_this_month: deliveredThisMonth,
                avg_delivery_days: avgDays
            }
        }
    },

    actions: {
        // Reset store
        resetStore() {
            this.shipments = []
        },
        // Sync mutations
        setShipments: base.actions.setter("shipments"),
        createShipment: base.actions.creator("shipments"),
        updateShipment: base.actions.updater("shipments"),
        removeShipment: base.actions.remover("shipments"),

        // Async backend actions - Usa el endpoint externo con stats
        async loadShipments() {
            const { paginated_factory } = await import('/src/utils/api.js')
            try {
                const response = await paginated_factory("external/shipments/")
                
                // Set shipments
                this.setShipments(response.data)
                
                // Set stats if available
                if (response.stats) {
                    this.stats = response.stats
                }
                
                return response
            } catch (error) {
                console.error('Error loading shipments:', error)
                throw error
            }
        },
        refreshShipment: base.actions.refresher("external/shipments/", "Shipment"),
    },
})
